export const auditLogsConstants = {
  ADMIN_AUDIT_LOGS: "ADMIN_AUDIT_LOGS",
  SPINNER: "SPINNER",
  DATE_SELECTION_LENGTH: 2,
};
